import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForDamagedLostOrStolenLuggage: 'false',
    areYouClaimingFor1: '',
    companyYouWereTravelingWith: '',
    areYouClaimingFor2: '',
    originForDamaged: '',
    flightNumberOriginForDamaged: '',
    airCarrierOriginForDamaged: '',
    destinationForDamaged: '',
    flightNumberDestinationForDamaged: '',
    airCarrierDestinationForDamaged: '',
    dateOfLoss: '',
    pleaseDescribeWhatOccurred: '',
    areYouClaimingFor3: '',
    ifOtherPleaseDescribeWhere: '',
    whoDidYouReportTo: '',
    ifOtherPleaseDescribe2: '',
    reportReferenceNumber: '',
    nameCustomerServiceDepartment: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    phoneNumber: '',
    contact: '',
    doYouHaveAnyFurtherDetailsToAdd: '',
    descriptionOfItems: [],
    // Do you have any other type of insurance?
    doYouHaveOtherTypeOfInsuranceBaggageLoss: 'false',
    companyNameBaggageLoss: '',
    addressBaggageLoss: '',
    cityOrTownBaggageLoss: '',
    countryBaggageLoss: '',
    postalCodeBaggageLoss: '',
    typeOfPolicyBaggageLoss: '',
    policyBaggageLoss: '',
    contactBaggageLoss: '',
    phoneBaggageLoss: '',

    // Baggage delay
    areYouClaimingForBaggageDelay: 'false',
    travelSupplierInformation: '',
    companyBaggageDelay: '',
    originForBaggageDelay: '',
    flightNumberOriginForBaggageDelay: '',
    airCarrierOriginForBaggageDelay: '',
    destinationForBaggageDelay: '',
    flightNumberDestinationForBaggageDelay: '',
    airCarrierDestinationForBaggageDelay: '',
    dateWhenYourLuggageWasDelayed: '',
    timeWhenYourLuggageWasDelayed: '',
    dateWhenYourLuggageWasReturned: '',
    timeWhenYourLuggageWasReturned: '',
    haveYouMadeAClaimWithYourTravelProvider: 'false',
    descriptionOfItemsForDamaged: [],
    // Do you have any other type of insurance?
    doYouHaveOtherTypeOfInsuranceBaggageDelay: 'false',
    companyNameBaggageDelay: '',
    addressBaggageDelay: '',
    cityOrTownBaggageDelay: '',
    countryBaggageDelay: '',
    postalCodeBaggageDelay: '',
    typeOfPolicyBaggageDelay: '',
    policyBaggageDelay: '',
    contactBaggageDelay: '',
    phoneBaggageDelay: '',
    // Are you claiming for a Specified Item?
    areYouClaimingForASpecifiedItem: 'false',
    specifiedItems: [],
  },
  errors: [],
});

const initialForDamagedLostOrStolenLuggageState = {
  form: {
    areYouClaimingForDamagedLostOrStolenLuggage: 'false',
    areYouClaimingFor1: '',
    companyYouWereTravelingWith: '',
    areYouClaimingFor2: '',
    originForDamaged: '',
    flightNumberOriginForDamaged: '',
    airCarrierOriginForDamaged: '',
    destinationForDamaged: '',
    flightNumberDestinationForDamaged: '',
    airCarrierDestinationForDamaged: '',
    dateOfLoss: '',
    pleaseDescribeWhatOccurred: '',
    areYouClaimingFor3: '',
    ifOtherPleaseDescribeWhere: '',
    whoDidYouReportTo: '',
    ifOtherPleaseDescribe2: '',
    reportReferenceNumber: '',
    nameCustomerServiceDepartment: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    phoneNumber: '',
    contact: '',
    doYouHaveAnyFurtherDetailsToAdd: '',
    descriptionOfItems: [],
  },
};

const initialForBaggageDelayState = {
  form: {
    areYouClaimingForBaggageDelay: 'false',
    companyBaggageDelay: '',
    originForBaggageDelay: '',
    flightNumberOriginForBaggageDelay: '',
    airCarrierOriginForBaggageDelay: '',
    destinationForBaggageDelay: '',
    flightNumberDestinationForBaggageDelay: '',
    airCarrierDestinationForBaggageDelay: '',
    dateWhenYourLuggageWasDelayed: '',
    timeWhenYourLuggageWasDelayed: '',
    dateWhenYourLuggageWasReturned: '',
    timeWhenYourLuggageWasReturned: '',
    haveYouMadeAClaimWithYourTravelProvider: 'false',
    descriptionOfItemsForDamaged: [],
  },
};

function stepBaggageAndPersonalItemsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'descriptionOfItems'], [])
           .mergeDeep(initialForDamagedLostOrStolenLuggageState);
    case RESET_TRAVEL_DELAY_STATE:
      return state
          .setIn(['form', 'descriptionOfItemsForDamaged'], [])
          .mergeDeep(initialForBaggageDelayState);
    default:
      return state;
  }
}

export default stepBaggageAndPersonalItemsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBaggageAndPersonalItems/reducer.js